import type { Grade, Lesson } from '@chessmate/lessons';
import { lessonCover } from '@chessmate/lessons';
import { GraduationCap } from 'lucide-react';
import { ProgressStars } from './ProgressStars.js';

export interface LessonCardProps {
  readonly lesson: Lesson;
  readonly best?: Grade | null;
  readonly onOpen: () => void;
}

export function LessonCard({ lesson, best = null, onOpen }: LessonCardProps) {
  const cover = lessonCover(lesson);
  return (
    <button
      type="button"
      data-testid={`lesson-card-${lesson.id}`}
      onClick={onOpen}
      className="group flex min-w-0 flex-col gap-2 rounded-2xl border border-border bg-surface p-4 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      {cover ? (
        <img
          src={cover}
          alt=""
          data-testid={`lesson-cover-${lesson.id}`}
          className="h-24 w-full rounded-xl object-cover"
        />
      ) : null}
      <div className="flex items-center justify-between gap-2">
        <GraduationCap className="text-accent" size={24} />
        <ProgressStars grade={best} size={20} />
      </div>
      <h3 className="font-display text-base font-bold text-fg [overflow-wrap:anywhere]">{lesson.title}</h3>
      <div className="flex flex-wrap gap-1">
        {lesson.concepts.map((c) => (
          <span
            key={c}
            className="max-w-full rounded-full bg-accent-soft px-2 py-0.5 text-xs font-bold text-accent [overflow-wrap:anywhere]"
          >
            {c.replaceAll('-', ' ')}
          </span>
        ))}
      </div>
    </button>
  );
}
